<script lang="ts" setup>
import { VueTelInput } from 'vue-tel-input'

// add type
const props = defineProps<{
  context: any
}>()

const phone = ref(props.context?._value)
const vueTelInputRef = ref()

const inputOptions = computed(() => {
  return {
    ...VueTelInput.props.inputOptions,
    ...{
      placeholder: '',
      type: 'tel',
      id: props.context.id,
    },
  }
})

const handleValidate = (phoneObject: any) => {
  // Extract data from the phone object
  // Note: phoneObject.number is in E.164 format (+41222222222) for backend compatibility
  // while the display shows user-friendly formatting (41 22 222 22 22)
  const number = phoneObject?.number || ''
  const isValid = phoneObject?.valid || false

  // Update FormKit with the phone number in E.164 format
  props.context?.node.input(number)

  // Update validation state
  props.context?.attrs['handle-validate-fn'](isValid)
  props.context?.attrs['handle-phone-object-fn'](phoneObject)
}

// Handle the v-model update separately
const handleModelUpdate = (value: string) => {
  // The v-model handles the display value, we'll get validation from @validate
}
</script>

<template>
  <VueTelInput
    ref="vueTelInputRef"
    v-model="phone"
    mode="international"
    default-country="ch"
    :auto-format="true"
    :input-options="inputOptions"
    @update:model-value="handleModelUpdate"
    @focus="() => props.context?.attrs['handle-focus-fn'](true)"
    @blur="() => props.context?.attrs['handle-focus-fn'](false)"
    @validate="handleValidate"
  />
</template>

<style lang="scss" scoped>
.vue-tel-input {
  &:focus-within {
    box-shadow: none;
    border: 1px solid var(--c-primary);
  }

  :deep(.vti__input) {
    border: none;

    &:focus {
      border: none;
    }
  }
}
</style>
